import * as yup from 'yup'
import { companySchema } from '../company/general.schema.js'
import { VALIDATION } from '../constants.js'
import { recruiterSchema } from '../recruiter/schema.js'

import {
  requiredString,
  requiredNumber,
  pageNum,
  pageSize
} from '../yup/schemas.js'

import allowedValues from './allowed.values.js'

const { MESSAGES } = VALIDATION

export const referralSchema = yup.object({
  id: requiredString.uuid(),
  timeType: requiredString.oneOf(allowedValues.timeTypesArr),
  timeNumber: requiredNumber,
  code: requiredString,
  discount: yup.number().positive().required().max(100).min(0)
    .test('is-divisible-by-5-and-not-in-range-91-99', MESSAGES.MUST_BE_DIVISIBLE_BY_FIVE_AND_CAN_NOT_BE_IN_RANGE, (value) => {
      return (value % 5) === 0 && (value === 100 || value <= 90)
    }),
  companyId: companySchema.get('id')
}).objectRequired()

const createReferralSchema = referralSchema.pick([
  'timeType',
  'timeNumber',
  'code',
  'discount',
  'companyId'
])

const getReferralListByAdminQueryParamsSchema = yup.object({
  pageNum,
  pageSize,
  expired: yup.bool()
}).objectRequired()

const getReferralListByRecruiterQueryParamsSchema = yup.object({
  pageNum,
  pageSize
})

const getReferralListByRecruiterParamsSchema = yup.object({
  recruiterId: recruiterSchema.get('id')
}).objectRequired()

const deactivateReferralParamsSchema = yup.object({
  id: referralSchema.get('id')
}).objectRequired()

const getReferralExistsByCodeParamsSchema = yup.object({
  code: referralSchema.get('code')
}).objectRequired()

const createReferralSchemas = { back: createReferralSchema, front: createReferralSchema }

const getReferralListByAdminQueryParamsSchemas = { front: getReferralListByAdminQueryParamsSchema, back: getReferralListByAdminQueryParamsSchema }
const getReferralListByRecruiterQueryParamsSchemas = { front: getReferralListByRecruiterQueryParamsSchema, back: getReferralListByRecruiterQueryParamsSchema }

const getReferralListByRecruiterParamsSchemas = { back: getReferralListByRecruiterParamsSchema, front: getReferralListByRecruiterParamsSchema }

const deactivateReferralParamsSchemas = { back: deactivateReferralParamsSchema, front: deactivateReferralParamsSchema }

const getReferralExistsByCodeParamsSchemas = { back: getReferralExistsByCodeParamsSchema, front: getReferralExistsByCodeParamsSchema }

export default {
  createReferral: createReferralSchemas,
  getReferralListByAdminQueryParams: getReferralListByAdminQueryParamsSchemas,
  getReferralListByRecruiterQueryParams: getReferralListByRecruiterQueryParamsSchemas,
  getReferralListByRecruiterParams: getReferralListByRecruiterParamsSchemas,
  deactivateReferralParams: deactivateReferralParamsSchemas,
  getReferralExistsByCodeParams: getReferralExistsByCodeParamsSchemas,
  allowedValues
}
